import { FilterData } from "./filter.js";

export enum FilterTypeEnum {
  Dropdown = 1,
  DateRange = 2,
  Autocomplete = 3,
}

export enum ChatFilterOperator {
  Eq = 'eq',
  Neq = 'neq',
  // Gt = 'gt',
  // Gte = 'gte',
  // Lt = 'lt',
  // Lte = 'lte',

  MoreRecentThan = 'more-recent-than',
  PriorTo = 'prior-to',
}

export const chatFilterOperatorsMap: Record<ChatFilterOperator, string> = {
  [ChatFilterOperator.Eq]: 'Equals',
  [ChatFilterOperator.Neq]: 'Not Equals',
  // [ChatFilterOperator.Gt]: 'Greater Than',
  // [ChatFilterOperator.Gte]: 'Greater Than or Equals',
  // [ChatFilterOperator.Lt]: 'Less Than',
  // [ChatFilterOperator.Lte]: 'Less Than or Equals',

  [ChatFilterOperator.MoreRecentThan]: 'More Recent Than',
  [ChatFilterOperator.PriorTo]: 'Prior To',
};

export function getFilterTypeLabel(type: FilterTypeEnum): string {
  switch (type) {
    case FilterTypeEnum.Dropdown:
      return 'Dropdown';
    case FilterTypeEnum.DateRange:
      return 'Date Range';
    case FilterTypeEnum.Autocomplete:
      return 'Autocomplete';
    default:
      return 'Unknown';
  }
}

export function getFilterTypeOperatorsValue(type: FilterTypeEnum): ChatFilterOperator[] {
  switch (type) {
    case FilterTypeEnum.Dropdown:
      return [ChatFilterOperator.Eq, ChatFilterOperator.Neq];
    case FilterTypeEnum.DateRange:
      return [ChatFilterOperator.MoreRecentThan, ChatFilterOperator.PriorTo];
    case FilterTypeEnum.Autocomplete:
      return [ChatFilterOperator.Eq, ChatFilterOperator.Neq];
    default:
      return [];
  }
}

export function getFilterTypeOperatorsLabel(type: FilterTypeEnum): string[] {
  switch (type) {
    case FilterTypeEnum.Dropdown:
      return [chatFilterOperatorsMap[ChatFilterOperator.Eq], chatFilterOperatorsMap[ChatFilterOperator.Neq]];
    case FilterTypeEnum.DateRange:
      return [
        chatFilterOperatorsMap[ChatFilterOperator.MoreRecentThan],
        chatFilterOperatorsMap[ChatFilterOperator.PriorTo],
      ];
    default:
      return [];
  }
}

export function getFilterTypeValues(type: FilterTypeEnum): string[] {
  switch (type) {
    case FilterTypeEnum.Dropdown:
      return [];
    case FilterTypeEnum.DateRange:
      return ['Last 7 Days', 'Last 30 Days', 'Last 90 Days', 'Last Year'];
    default:
      return [];
  }
}

export function getDefaultFilterData<T extends FilterTypeEnum>(type: T): FilterData<T> {
  switch (type) {
    case FilterTypeEnum.Dropdown:
    case FilterTypeEnum.DateRange:
      return {
        items: getFilterTypeValues(type).map((value, index) => ({
          key: `option_${index}`,
          value,
        })),
      };
    case FilterTypeEnum.Autocomplete: {
      return { endpoint: '' };
    }
    default: throw new Error(`Unsupported filter type: ${type}`);
  }
}

export function getFilterDataDisplayText<T extends FilterTypeEnum>(data: FilterData<T>, type: T): string {
  switch (type) {
    case FilterTypeEnum.Dropdown:
    case FilterTypeEnum.DateRange:
      const castedData = data as FilterData<FilterTypeEnum.Dropdown | FilterTypeEnum.DateRange>;
      return castedData.items.map(item => item.value).join(', ');
    case FilterTypeEnum.Autocomplete:
      const castedDataAutocomplete = data as FilterData<FilterTypeEnum.Autocomplete>;
      return castedDataAutocomplete.endpoint;
    default:
      return '';
  }
}